module.exports = __webpack_public_path__ + "static/b1-zane-0ecac4751ffdad2dc6391178ec6d8c35.jpg";